import { IsBoolean } from "class-validator";

export class CustomerSettingsDto {
    @IsBoolean()
    attachUsageLogsCsv = false;
  
    @IsBoolean()
    attachUsageLogsPdf = true;
  }
  